@file:Suppress(
    "RETURN_VALUE_NOT_USED",
    "RETURN_VALUE_NOT_USED_COERCION",
)

import com.varabyte.kobweb.core.AppGlobals
import com.varabyte.kobweb.navigation.BasePath
import com.varabyte.kobweb.navigation.Router
import com.varabyte.kobweb.navigation.UpdateHistoryMode
import com.varabyte.kobweb.navigation.remove
import com.varabyte.kobweb.silk.defer.DeferringHost
import kotlin.Suppress
import kotlinx.browser.document
import kotlinx.browser.window
import org.jetbrains.compose.web.renderComposable
import org.lennycodes.hldi.components.Login as _org_lennycodes_hldi_components_Login
import org.lennycodes.hldi.pages.AboutPage as _org_lennycodes_hldi_pages_AboutPage
import org.lennycodes.hldi.pages.BlogPage as _org_lennycodes_hldi_pages_BlogPage
import org.lennycodes.hldi.pages.ContactPage as _org_lennycodes_hldi_pages_ContactPage
import org.lennycodes.hldi.pages.EventsPage as _org_lennycodes_hldi_pages_EventsPage
import org.lennycodes.hldi.pages.GalleryPage as _org_lennycodes_hldi_pages_GalleryPage
import org.lennycodes.hldi.pages.GetInvolvedPage as _org_lennycodes_hldi_pages_GetInvolvedPage
import org.lennycodes.hldi.pages.HomePage as _org_lennycodes_hldi_pages_HomePage
import org.lennycodes.hldi.pages.ProgramsPage as _org_lennycodes_hldi_pages_ProgramsPage
import org.lennycodes.hldi.pages.ProjectsPage as _org_lennycodes_hldi_pages_ProjectsPage
import org.lennycodes.hldi.pages.ResourcesPage as _org_lennycodes_hldi_pages_ResourcesPage
import org.lennycodes.hldi.pages.TeamPage as _org_lennycodes_hldi_pages_TeamPage
import org.lennycodes.hldi.pages.admin.Admin as _org_lennycodes_hldi_pages_admin_Admin
import org.lennycodes.hldi.pages.admin.AdminAbout as _org_lennycodes_hldi_pages_admin_AdminAbout
import org.lennycodes.hldi.pages.admin.AdminBlog as _org_lennycodes_hldi_pages_admin_AdminBlog
import org.lennycodes.hldi.pages.admin.AdminEvent as _org_lennycodes_hldi_pages_admin_AdminEvent
import org.lennycodes.hldi.pages.admin.AdminGallery as _org_lennycodes_hldi_pages_admin_AdminGallery
import org.lennycodes.hldi.pages.admin.AdminResources as _org_lennycodes_hldi_pages_admin_AdminResources

public fun main() {
    AppGlobals.initialize(mapOf("title" to "HLDI"))
    BasePath.set("")
    val router = Router()
    com.varabyte.kobweb.core.init.initKobweb(router) { ctx ->
        ctx.router.register(
            "/",
        ) { pageCtx -> 
            _org_lennycodes_hldi_pages_HomePage()
        }
        ctx.router.register(
            "/about",
        ) { pageCtx -> 
            _org_lennycodes_hldi_pages_AboutPage()
        }
        ctx.router.register(
            "/admin",
        ) { pageCtx -> 
            _org_lennycodes_hldi_pages_admin_Admin()
        }
        ctx.router.register(
            "/admin-about",
        ) { pageCtx -> 
            _org_lennycodes_hldi_pages_admin_AdminAbout()
        }
        ctx.router.register(
            "/admin-blog",
        ) { pageCtx -> 
            _org_lennycodes_hldi_pages_admin_AdminBlog()
        }
        ctx.router.register(
            "/admin-events",
        ) { pageCtx -> 
            _org_lennycodes_hldi_pages_admin_AdminEvent()
        }
        ctx.router.register(
            "/admin-gallery",
        ) { pageCtx -> 
            _org_lennycodes_hldi_pages_admin_AdminGallery()
        }
        ctx.router.register(
            "/admin-resources",
        ) { pageCtx -> 
            _org_lennycodes_hldi_pages_admin_AdminResources()
        }
        ctx.router.register(
            "/blog",
        ) { pageCtx -> 
            _org_lennycodes_hldi_pages_BlogPage()
        }
        ctx.router.register(
            "/contact",
        ) { pageCtx -> 
            _org_lennycodes_hldi_pages_ContactPage()
        }
        ctx.router.register(
            "/events",
        ) { pageCtx -> 
            _org_lennycodes_hldi_pages_EventsPage()
        }
        ctx.router.register(
            "/gallery",
        ) { pageCtx -> 
            _org_lennycodes_hldi_pages_GalleryPage()
        }
        ctx.router.register(
            "/get-involved",
        ) { pageCtx -> 
            _org_lennycodes_hldi_pages_GetInvolvedPage()
        }
        ctx.router.register(
            "/login",
        ) { pageCtx -> 
            _org_lennycodes_hldi_components_Login()
        }
        ctx.router.register(
            "/programs",
        ) { pageCtx -> 
            _org_lennycodes_hldi_pages_ProgramsPage()
        }
        ctx.router.register(
            "/projects",
        ) { pageCtx -> 
            _org_lennycodes_hldi_pages_ProjectsPage()
        }
        ctx.router.register(
            "/resources",
        ) { pageCtx -> 
            _org_lennycodes_hldi_pages_ResourcesPage()
        }
        ctx.router.register(
            "/team",
        ) { pageCtx -> 
            _org_lennycodes_hldi_pages_TeamPage()
        }

    }
    router.addRouteInterceptor {
        path = path.removeSuffix(".html").removeSuffix(".htm")
    }

    com.varabyte.kobweb.silk.init.additionalSilkInitialization = { ctx ->
        com.varabyte.kobweb.silk.init.initSilkWidgets(ctx)
        com.varabyte.kobweb.silk.init.initSilkWidgetsKobweb(ctx)
        ctx.theme.registerStyle("fade-in-animation", org.lennycodes.hldi.components.FadeInAnimation)
        ctx.theme.registerStyle("slide-up-animation", org.lennycodes.hldi.components.SlideUpAnimation)
        ctx.theme.registerStyle("team-dialog-backdrop", org.lennycodes.hldi.components.TeamDialogBackdropStyle)
        ctx.theme.registerStyle("team-dialog-card", org.lennycodes.hldi.components.TeamDialogCardStyle)
        ctx.theme.registerStyle("team-dialog-close-button", org.lennycodes.hldi.components.TeamDialogCloseButtonStyle)
        ctx.theme.registerStyle("team-profile-image", org.lennycodes.hldi.components.TeamProfileImageStyle)
        ctx.theme.registerStyle("dialog-backdrop", org.lennycodes.hldi.pages.admin.DialogBackdropStyle)
        ctx.theme.registerStyle("dialog-card", org.lennycodes.hldi.pages.admin.DialogCardStyle)
        ctx.theme.registerStyle("dialog-title", org.lennycodes.hldi.pages.admin.DialogTitleStyle)
        ctx.theme.registerStyle("dialog-subtitle", org.lennycodes.hldi.pages.admin.DialogSubtitleStyle)
        ctx.theme.registerStyle("field-group", org.lennycodes.hldi.pages.admin.FieldGroupStyle)
        ctx.theme.registerStyle("field-label", org.lennycodes.hldi.pages.admin.FieldLabelStyle)
        ctx.theme.registerStyle("field-input", org.lennycodes.hldi.pages.admin.FieldInputStyle)
        ctx.theme.registerStyle("dialog-actions-row", org.lennycodes.hldi.pages.admin.DialogActionsRowStyle)
        ctx.theme.registerStyle("cancel-button", org.lennycodes.hldi.pages.admin.CancelButtonStyle)
        ctx.theme.registerStyle("save-button", org.lennycodes.hldi.pages.admin.SaveButtonStyle)
        ctx.theme.registerStyle("hldi-theme_base", org.lennycodes.hldi.constants.HLDITheme.baseStyle)
        ctx.theme.registerStyle("hldi-theme_card", org.lennycodes.hldi.constants.HLDITheme.cardStyle)
        ctx.theme.registerStyle("hldi-theme_button", org.lennycodes.hldi.constants.HLDITheme.buttonStyle)
        ctx.theme.registerStyle("useful-link", org.lennycodes.hldi.styles.UsefulLinkStyle)
        ctx.theme.registerStyle("subscribe-button", org.lennycodes.hldi.styles.SubscribeButtonStyle)
        ctx.theme.registerStyle("bottom-bar", org.lennycodes.hldi.styles.BottomBarStyle)
        ctx.theme.registerStyle("newsletter-input", org.lennycodes.hldi.styles.NewsletterInputStyle)
        ctx.theme.registerStyle("nav-bar", org.lennycodes.hldi.styles.NavBarStyle)
        ctx.theme.registerStyle("logo", org.lennycodes.hldi.styles.LogoStyle)
        ctx.theme.registerStyle("desktop-nav-div", org.lennycodes.hldi.styles.DesktopNavDiv)
        ctx.theme.registerStyle("nav-item", org.lennycodes.hldi.styles.NavItemStyle)
        ctx.theme.registerStyle("mobile-nav-div", org.lennycodes.hldi.styles.MobileNavDiv)
        ctx.theme.registerStyle("donate-btn", org.lennycodes.hldi.styles.DonateBtnStyle)
        ctx.theme.registerStyle("mobile-menu", org.lennycodes.hldi.styles.MobileMenuStyle)
        ctx.theme.registerStyle("logo-text", org.lennycodes.hldi.styles.LogoTextStyle)
        ctx.theme.registerStyle("home-hero", org.lennycodes.hldi.styles.HomeHeroStyle)
        ctx.theme.registerStyle("hero-donate", org.lennycodes.hldi.styles.HeroDonateStyle)
        ctx.theme.registerStyle("program-card", org.lennycodes.hldi.styles.ProgramCardStyle)
        ctx.theme.registerStyle("button", org.lennycodes.hldi.styles.ButtonStyle)
        ctx.theme.registerStyle("delete-button", org.lennycodes.hldi.styles.DeleteButtonStyle)
        ctx.theme.registerStyle("core-values", org.lennycodes.hldi.styles.coreValuesStyle)
        ctx.theme.registerStyle("mission-vision-card", org.lennycodes.hldi.styles.missionVisionCardStyle)
        ctx.theme.registerStyle("contact-hero", org.lennycodes.hldi.styles.contactHeroStyle)
        ctx.theme.registerStyle("contact-hero-title", org.lennycodes.hldi.styles.contactHeroTitleStyle)
        ctx.theme.registerStyle("contact-info-card", org.lennycodes.hldi.styles.contactInfoCardStyle)
        ctx.theme.registerStyle("social-link", org.lennycodes.hldi.styles.socialLinkStyle)
        ctx.theme.registerStyle("social-links-row", org.lennycodes.hldi.styles.SocialLinksRowStyle)
        ctx.theme.registerStyle("social-icon-button", org.lennycodes.hldi.styles.SocialIconButtonStyle)
        ctx.theme.registerStyle("send-message", org.lennycodes.hldi.styles.SendMessageStyle)
        ctx.theme.registerStyle("map", org.lennycodes.hldi.styles.MapStyle)
        ctx.theme.registerStyle("team-card", org.lennycodes.hldi.styles.TeamCardStyle)
        ctx.theme.registerStyle("team-card-leadership-badge", org.lennycodes.hldi.styles.TeamCardLeadershipBadgeStyle)
        ctx.theme.registerStyle("team-card-content", org.lennycodes.hldi.styles.TeamCardContentStyle)
        ctx.theme.registerStyle("team-card-name", org.lennycodes.hldi.styles.TeamCardNameStyle)
        ctx.theme.registerStyle("team-card-role", org.lennycodes.hldi.styles.TeamCardRoleStyle)
        ctx.theme.registerStyle("team-card-role-underline", org.lennycodes.hldi.styles.TeamCardRoleUnderlineStyle)
        ctx.theme.registerStyle("team-card-bio", org.lennycodes.hldi.styles.TeamCardBioStyle)
        ctx.theme.registerStyle("view-profile-button", org.lennycodes.hldi.styles.ViewProfileButtonStyle)
        ctx.theme.registerStyle("team-card-department", org.lennycodes.hldi.styles.TeamCardDepartmentStyle)
        ctx.theme.registerStyle("team-card-image-wrapper", org.lennycodes.hldi.styles.TeamCardImageWrapperStyle)
        ctx.theme.registerStyle("team-card-image", org.lennycodes.hldi.styles.TeamCardImageStyle)
        ctx.theme.registerStyle("department", org.lennycodes.hldi.styles.DepartmentStyle)
        ctx.theme.registerStyle("project-card", org.lennycodes.hldi.styles.ProjectCardStyle)
        ctx.theme.registerStyle("blog-card", org.lennycodes.hldi.styles.BlogCardStyle)
        ctx.theme.registerStyle("gallery-image", org.lennycodes.hldi.styles.GalleryImageStyle)
        ctx.theme.registerStyle("gallery-overlay", org.lennycodes.hldi.styles.GalleryOverlayStyle)
        ctx.theme.registerStyle("gallery-container", org.lennycodes.hldi.styles.GalleryContainerStyle)
        ctx.theme.registerStyle("gallery-grid", org.lennycodes.hldi.styles.GalleryGridStyle)
        ctx.theme.registerStyle("lightbox-overlay", org.lennycodes.hldi.styles.LightboxOverlayStyle)
        ctx.theme.registerStyle("lightbox-content", org.lennycodes.hldi.styles.LightboxContentStyle)
        ctx.theme.registerStyle("lightbox-close-button", org.lennycodes.hldi.styles.LightboxCloseButtonStyle)
        ctx.theme.registerStyle("lightbox-image", org.lennycodes.hldi.styles.LightboxImageStyle)
        ctx.theme.registerStyle("lightbox-caption", org.lennycodes.hldi.styles.LightboxCaptionStyle)
        ctx.theme.registerStyle("timeline-item", org.lennycodes.hldi.styles.TimelineItem)
        ctx.theme.registerStyle("timeline-item-left", org.lennycodes.hldi.styles.TimelineItemLeft)
        ctx.theme.registerStyle("timeline-item-right", org.lennycodes.hldi.styles.TimelineItemRight)
        ctx.theme.registerStyle("timeline-card-left", org.lennycodes.hldi.styles.TimelineCardLeft)
        ctx.theme.registerStyle("timeline-card-right", org.lennycodes.hldi.styles.TimelineCardRight)
        ctx.theme.registerStyle("timeline-container", org.lennycodes.hldi.styles.TimelineContainer)
        ctx.theme.registerStyle("timeline-row", org.lennycodes.hldi.styles.TimelineRow)
        ctx.theme.registerStyle("timeline-accent-bar", org.lennycodes.hldi.styles.TimelineAccentBar)
        ctx.theme.registerStyle("timeline-year-badge", org.lennycodes.hldi.styles.TimelineYearBadge)
        ctx.theme.registerStyle("timeline-divider", org.lennycodes.hldi.styles.TimelineDivider)
        ctx.theme.registerStyle("timeline-event-text", org.lennycodes.hldi.styles.TimelineEventText)
        ctx.theme.registerStyle("submit-button", org.lennycodes.hldi.styles.SubmitButtonStyle)
        ctx.theme.registerStyle("text-area", org.lennycodes.hldi.styles.TextAreaStyle)
        ctx.theme.registerStyle("app-input", org.lennycodes.hldi.styles.AppInputStyle)
        ctx.theme.registerStyle("partner-card", org.lennycodes.hldi.styles.PartnerCardStyle)
        ctx.theme.registerStyle("supporter-card", org.lennycodes.hldi.styles.SupporterCardStyle)
        ctx.theme.registerStyle("payment-methods-card", org.lennycodes.hldi.styles.PaymentMethodsCardStyle)
        ctx.theme.registerStyle("payment-methods-heading", org.lennycodes.hldi.styles.PaymentMethodsHeadingStyle)
        ctx.theme.registerStyle("payment-method-block", org.lennycodes.hldi.styles.PaymentMethodBlockStyle)
        ctx.theme.registerStyle("payment-method-heading", org.lennycodes.hldi.styles.PaymentMethodHeadingStyle)
        ctx.theme.registerStyle("payment-row", org.lennycodes.hldi.styles.PaymentRowStyle)
        ctx.theme.registerStyle("payment-label", org.lennycodes.hldi.styles.PaymentLabelStyle)
        ctx.theme.registerStyle("payment-value", org.lennycodes.hldi.styles.PaymentValueStyle)
        ctx.theme.registerStyle("back-to-top-tooltip", org.lennycodes.hldi.styles.BackToTopTooltipStyle)
        ctx.theme.registerStyle("scroll-to-top", org.lennycodes.hldi.styles.ScrollToTopStyle)
        ctx.theme.registerStyle("scroll-to-top-visible", org.lennycodes.hldi.styles.ScrollToTopVisibleStyle)
        ctx.theme.registerStyle("footer", org.lennycodes.hldi.styles.FooterStyle)
        ctx.theme.registerStyle("footer-social-links-row", org.lennycodes.hldi.styles.FooterSocialLinksRowStyle)
        ctx.theme.registerStyle("footer-social-icon-button", org.lennycodes.hldi.styles.FooterSocialIconButtonStyle)
        ctx.theme.registerStyle("footer-wave-svg", org.lennycodes.hldi.styles.FooterWaveSvgStyle)
        ctx.theme.registerStyle("section-wave-svg", org.lennycodes.hldi.styles.SectionWaveSvgStyle)
        ctx.theme.registerStyle("about-hero-section", org.lennycodes.hldi.styles.AboutHeroSectionStyle)
        ctx.theme.registerStyle("about-hero-title", org.lennycodes.hldi.styles.AboutHeroTitleStyle)
        ctx.theme.registerStyle("about-hero-text", org.lennycodes.hldi.styles.AboutHeroTextStyle)
        ctx.theme.registerStyle("spinner", org.lennycodes.hldi.styles.SpinnerStyle)
        ctx.theme.registerStyle("hero-section", org.lennycodes.hldi.styles.HeroSectionStyle)
        ctx.theme.registerStyle("hero-title", org.lennycodes.hldi.styles.HeroTitleStyle)
        ctx.theme.registerStyle("hero-text", org.lennycodes.hldi.styles.HeroTextStyle)
        ctx.theme.registerStyle("developer-credit-link", org.lennycodes.hldi.styles.DeveloperCreditLinkStyle)
        ctx.theme.registerStyle("login-page", org.lennycodes.hldi.styles.LoginPageStyle)
        ctx.theme.registerStyle("login-card", org.lennycodes.hldi.styles.LoginCardStyle)
        ctx.theme.registerStyle("login-logo", org.lennycodes.hldi.styles.LoginLogoStyle)
        ctx.theme.registerStyle("login-title", org.lennycodes.hldi.styles.LoginTitleStyle)
        ctx.theme.registerStyle("login-subtitle", org.lennycodes.hldi.styles.LoginSubtitleStyle)
        ctx.theme.registerStyle("login-field-group", org.lennycodes.hldi.styles.LoginFieldGroupStyle)
        ctx.theme.registerStyle("login-label", org.lennycodes.hldi.styles.LoginLabelStyle)
        ctx.theme.registerStyle("login-input", org.lennycodes.hldi.styles.LoginInputStyle)
        ctx.theme.registerStyle("login-button", org.lennycodes.hldi.styles.LoginButtonStyle)
        ctx.theme.registerStyle("login-error", org.lennycodes.hldi.styles.LoginErrorStyle)
        ctx.theme.registerStyle("users-header-row", org.lennycodes.hldi.styles.UsersHeaderRowStyle)
        ctx.theme.registerStyle("users-title", org.lennycodes.hldi.styles.UsersTitleStyle)
        ctx.theme.registerStyle("add-admin-button", org.lennycodes.hldi.styles.AddAdminButtonStyle)
        ctx.theme.registerStyle("table-card", org.lennycodes.hldi.styles.TableCardStyle)
        ctx.theme.registerStyle("admin-table", org.lennycodes.hldi.styles.AdminTableStyle)
        ctx.theme.registerStyle("table-header-cell", org.lennycodes.hldi.styles.TableHeaderCellStyle)
        ctx.theme.registerStyle("table-row", org.lennycodes.hldi.styles.TableRowStyle)
        ctx.theme.registerStyle("table-cell", org.lennycodes.hldi.styles.TableCellStyle)
        ctx.theme.registerStyle("avatar-badge", org.lennycodes.hldi.styles.AvatarBadgeStyle)
        ctx.theme.registerStyle("name-cell", org.lennycodes.hldi.styles.NameCellStyle)
        ctx.theme.registerStyle("icon-button", org.lennycodes.hldi.styles.IconButtonStyle)
        ctx.theme.registerStyle("edit-icon-button", org.lennycodes.hldi.styles.EditIconButtonStyle)
        ctx.theme.registerStyle("delete-icon-button", org.lennycodes.hldi.styles.DeleteIconButtonStyle)
        ctx.theme.registerStyle("volunteer-button", org.lennycodes.hldi.styles.VolunteerButtonStyle)
        ctx.theme.registerStyle("outline-button", org.lennycodes.hldi.styles.OutlineButtonStyle)
        ctx.theme.registerStyle("resource-card", org.lennycodes.hldi.styles.ResourceCardStyle)
        ctx.theme.registerStyle("category-badge", org.lennycodes.hldi.styles.CategoryBadgeStyle)
        ctx.theme.registerStyle("view-button", org.lennycodes.hldi.styles.ViewButtonStyle)
        ctx.theme.registerStyle("download-button", org.lennycodes.hldi.styles.DownloadButtonStyle)
        ctx.theme.registerKeyframes("fade-in-down", org.lennycodes.hldi.pages.FadeInDownKeyframes)
        ctx.theme.registerKeyframes("wobble", org.lennycodes.hldi.styles.WobbleKeyframes)
        ctx.theme.registerKeyframes("fade-in-up", org.lennycodes.hldi.styles.FadeInUpKeyframes)
        ctx.theme.registerKeyframes("spin", org.lennycodes.hldi.styles.SpinKeyframes)
        org.lennycodes.hldi.initStyles(ctx)
    }

    // Dedup any leading slashes after removing the origin, just in case someone typed
    // something like `https://site.com//about` by accident. If we pass `//about` into
    // `tryRoutingTo`, Kobweb will reject it as a protocol-relative URL; instead, we
    // want it to navigate to `/about`
    router.tryRoutingTo(BasePath.remove("/" + window.location.href.removePrefix(window.origin).trimStart('/')), UpdateHistoryMode.REPLACE)

    // For SEO, we may bake the contents of a page in at build time. However, we will
    // overwrite them the first time we render this page with their composable, dynamic
    // versions. Think of this as poor man's hydration :)
    // See also: https://en.wikipedia.org/wiki/Hydration_(web_development)
    val root = document.getElementById("_kobweb-root")!!
    while (root.firstChild != null) { root.removeChild(root.firstChild!!) }

    renderComposable(rootElementId = "_kobweb-root") {
        org.lennycodes.hldi.AppEntry {
            router.renderActivePage { DeferringHost { it() } }
        }
    }
}
